import { API } from "@/lib/api";

const logClick = (method, page) => {
  const body = new Blob([JSON.stringify({ method, page })], { type: "text/plain" });
  if (navigator.sendBeacon && navigator.sendBeacon(`${API}/track/click`, body)) return;
  fetch(`${API}/track/click`, { method: "POST", body, keepalive: true }).catch(() => {});
};

export function initCallTracking() {
  const onClick = (e) => {
    const page = window.location.pathname;
    if (page.startsWith("/admin")) return;
    const a = e.target.closest && e.target.closest("a[href]");
    if (!a) return;
    const href = a.getAttribute("href") || "";
    const isTel = href.startsWith("tel:");
    if (!isTel && !href.includes("wa.me/")) return;
    const method = isTel ? "phone" : "whatsapp";
    logClick(method, page);
    if (window.gtag) window.gtag("event", "click_to_call", { method, link_url: href, page_path: page });
  };
  document.addEventListener("click", onClick, true);
  return () => document.removeEventListener("click", onClick, true);
}
